import React, { useEffect, useState } from 'react';
import { Collapse, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import buildNavLinksFromBackendTabs from '../navLinks/Navlinks';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import smartsaIcon from '../assets/smartsa-new-icon-mobile.svg';
import axios from 'axios';
import '../sidenav/Sidenav.css'
import {ReactComponent as LogoutIcon} from '../assets/logout-icon.svg'
import { useLocalStorage } from '@uidotdev/usehooks';
import isDesktop from '../isDesktop';
import roleService from '../roles/roleService';
import {
  getStoredBackendTabs,
  getStoredTabIds,
  isAdminRole,
} from '../utils/access';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [openLead, setOpenLead] = React.useState(false);
  const [openManage, setOpenManage] = React.useState(false);
  const [openAnalytics, setOpenAnalytics] = React.useState(false);
  const [empName, setEmpName] = useState('')
  const [allowedTabIds, setAllowedTabIds] = useState(getStoredTabIds);
  const [backendTabs, setBackendTabs] = useState(getStoredBackendTabs);
  const userId = localStorage.getItem('userId');
  const userRole = localStorage.getItem('userRole');
  const [token] = useLocalStorage("token",null)
  const canSeeAllTabs = isAdminRole(userRole);
  const getTabKey = (tab) => tab.route || tab.title;

  const handleNavigation = (route) => {
    navigate(route);
    onClose();
  };

  const handleClick = () => {
    setOpen(!open);
  };

  const handleClickLead = () => {
    setOpenLead(!openLead);
  };

  const handleClickManage = () => {
    setOpenManage(!openManage);
  };

  const handleClickAnalytics = () => {
    setOpenAnalytics(!openAnalytics);
  };

  const filterAllowedTabs = (tabs) => {
    if (canSeeAllTabs) return tabs;
    const allowedTabIdSet = new Set(allowedTabIds.map((tabId) => String(tabId)));
    return tabs.filter((tab) => allowedTabIdSet.has(String(tab.id)));
  };

  const navLinks = buildNavLinksFromBackendTabs(backendTabs);

  const adminSection = navLinks.find(link => link.tag === "Admin");
  const adminTabs = adminSection ? filterAllowedTabs(adminSection.tabs) : [];

  const leadsSection = navLinks.find(link => link.tag === "Lead Management System");
  const leadTabs = leadsSection ? filterAllowedTabs(leadsSection.tabs) : [];

  const analyticsSection = navLinks.find(link => link.tag === "Analytics");
  const analyticsTabs = analyticsSection ? filterAllowedTabs(analyticsSection.tabs) : [];

  const ContentSection = navLinks.find(link => link.tag === "Content Management System");
  const contentTabs = ContentSection ? filterAllowedTabs(ContentSection.tabs) : [];


  const logoutHandler=async()=>{
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/user/logout`,
      );
    } catch (error) {
      console.error(error);
    }
  }

  const handleLogout = async() => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('userRole');
    localStorage.removeItem('tab_id');
    localStorage.removeItem('backend_tabs');
    await logoutHandler()
    navigate('/');
    
  };

  useEffect(() => {
    const fetchEmployeeName = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/auth/employees/${userId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });        
        setEmpName(response.data.data.emp_name || '');
        console.log(response.data.data.emp_name, " got the emp name");
      } catch (error) {
        console.error('Failed to fetch employee name:', error);
      }
    };

    if (userId && token) {
      fetchEmployeeName();
    }
  }, [userId, token]);

  useEffect(() => {
    let isMounted = true;

    const fetchRoleAccess = async () => {
      if (!token || !userRole) return;

      try {
        const tabs = await roleService.getTabs(token);
        const roleAccess = canSeeAllTabs
          ? null
          : await roleService.getRoleAccess(token, userRole);
        if (!isMounted) return;

        setBackendTabs(tabs);
        localStorage.setItem('backend_tabs', JSON.stringify(tabs));
        if (roleAccess) {
          setAllowedTabIds(roleAccess.tabIds);
          localStorage.setItem('tab_id', JSON.stringify(roleAccess.tabIds));
        } else {
          setAllowedTabIds([]);
        }
      } catch (error) {
        console.error('Failed to fetch employee role access:', error);
      }
    };

    fetchRoleAccess();

    return () => {
      isMounted = false;
    };
  }, [token, userRole, canSeeAllTabs]);

  const isDesktopDevice = isDesktop();
  return (
    <Drawer anchor="left" open={isOpen} onClose={onClose} PaperProps={{sx: !isDesktopDevice && {width: !isDesktopDevice && '11.25rem', backgroundColor: "#EAF1F7", top: !isDesktopDevice && '2.67rem', height: !isDesktopDevice && 'auto', bottom: !isDesktopDevice && '0', borderRadius: !isDesktopDevice && '0 4px 4px 0', overflowX: !isDesktopDevice && 'hidden'}}}>
      <Link to="/dashboard" style={{ textDecoration: 'none' }}>
        <div className='sidenav-top'>
          <div className='sidenav-name'>Hi, {empName}</div>
          <img src={smartsaIcon} style={{padding: '0.5rem', width: '2.3rem'}} alt="Logo"/>
        </div>
        </Link>
      <div style={{display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between'}}>
        <div>
          {adminTabs.length > 0 && (
            <List sx={{ paddingBottom: '0', paddingTop: '0' }}>
              <ListItemButton onClick={handleClick} style={{ padding: '0' }}>
                <ListItem className='list-item'>
                  <ListItemText disableTypography className='list-item-text'>Admin</ListItemText>
                  {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </ListItem>
              </ListItemButton>
              <Collapse in={open} timeout="auto" unmountOnExit>
                {adminTabs.map((tab) => (
                  <List component="div" key={getTabKey(tab)} sx={{ paddingBottom: '0', paddingTop: '0' }}>
                    <ListItemButton onClick={() => handleNavigation(tab.route)} style={{ padding: '0' }}>
                      <ListItem className='list-item'>
                        <ListItemText disableTypography sx={{ fontSize: isDesktopDevice ? "0.769vw" : "0.688rem" }}>{tab.title}</ListItemText>
                      </ListItem>
                    </ListItemButton>
                  </List>
                ))}
              </Collapse>
            </List>
          )}
          {leadTabs.length > 0 && (
            <List sx={{ paddingBottom: '0', paddingTop: '0' }}>
              <ListItemButton onClick={handleClickLead} style={{ padding: '0' }}>
                <ListItem className='list-item'>
                  <ListItemText disableTypography className='list-item-text'>Lead Management <br /> System</ListItemText>
                  {openLead ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </ListItem>
              </ListItemButton>
              <Collapse in={openLead} timeout="auto" unmountOnExit>
                {leadTabs.map((tab) => (
                  <List component="div" key={getTabKey(tab)} sx={{ paddingBottom: '0', paddingTop: '0' }}>
                    <ListItemButton onClick={() => handleNavigation(tab.route)} style={{ padding: '0' }}>
                      <ListItem className='list-item'>
                        <ListItemText disableTypography sx={{ fontSize: isDesktopDevice ? "0.769vw" : "0.688rem" }}>{tab.title}</ListItemText>
                      </ListItem>
                    </ListItemButton>
                  </List>
                ))}
              </Collapse>
            </List>
          )}
          {analyticsTabs.length > 0 && (
            <List sx={{ paddingBottom: '0', paddingTop: '0' }}>
              <ListItemButton onClick={handleClickAnalytics} style={{ padding: '0' }}>
                <ListItem className='list-item'>
                  <ListItemText disableTypography className='list-item-text'>Analytics</ListItemText>
                  {openAnalytics ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </ListItem>
              </ListItemButton>
              <Collapse in={openAnalytics} timeout="auto" unmountOnExit>
                {analyticsTabs.map((tab) => (
                  <List component="div" key={getTabKey(tab)} sx={{ paddingBottom: '0', paddingTop: '0' }}>
                    <ListItemButton onClick={() => handleNavigation(tab.route)} style={{ padding: '0' }}>
                      <ListItem className='list-item'>
                        <ListItemText disableTypography sx={{ fontSize: isDesktopDevice ? "0.769vw" : "0.688rem" }}>{tab.title}</ListItemText>
                      </ListItem>
                    </ListItemButton>
                  </List>
                ))}
              </Collapse>
            </List>
          )}
          {contentTabs.length > 0 && (
            <List sx={{ paddingBottom: '0', paddingTop: '0' }}>
              <ListItemButton onClick={handleClickManage} style={{ padding: '0' }}>
                <ListItem className='list-item'>
                  <ListItemText disableTypography className='list-item-text'>Content Management <br /> System</ListItemText>
                  {openManage ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </ListItem>
              </ListItemButton>
              <Collapse in={openManage} timeout="auto" unmountOnExit>
                {contentTabs.map((tab) => {
                  if((tab.route==="/review-questions" || tab.route === "/generate-questions") && !isDesktopDevice) return null;
                  return (
                  <List component="div" disablePadding key={getTabKey(tab)} sx={{ paddingBottom: '0', paddingTop: '0' }}>
                    <ListItemButton onClick={() => handleNavigation(tab.route)} style={{ padding: '0' }}>
                      <ListItem className='list-item'>
                        <ListItemText disableTypography sx={{ fontSize: isDesktopDevice ? "0.769vw" : "0.688rem" }}>{tab.title}</ListItemText>
                      </ListItem>
                    </ListItemButton>
                  </List>);
                })}
              </Collapse>
            </List>
          )}
        </div>
        <div>
          <List>
            <ListItemButton onClick={handleLogout}>
              <ListItem style={{paddingLeft: '0'}}>
                <ListItemIcon style={{ minWidth: '0', marginRight: isDesktopDevice ? '0.513vw' : '0.5rem' }}>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText style={{ fontSize: isDesktopDevice ? '1.026vw' : '0.688rem' }}>
                  Logout
                </ListItemText>
              </ListItem>
            </ListItemButton>
          </List>
        </div>
      </div>
    </Drawer>
  );
};

export default Sidebar;
